<template>
  <div class="default-menu">
    <div class="default-menu__header">
      <div class="default-menu__header-top">
        <span class="default-menu__title">Фильтр</span>
        <button type="button" class="default-menu__close" @click="$emit('close')">
          <IconComponent name="close" />
        </button>
      </div>
    </div>
    <div class="default-menu__body filter-menu__body">
      <CatalogFiltersComponent :is-filter-menu="true" />
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import CatalogFiltersComponent from "@/views/catalog/components/CatalogFiltersComponent.vue";

export default {
  name: "FilterMenu",
  components: { CatalogFiltersComponent, IconComponent },
};
</script>

<style lang="stylus">
.filter-menu {
  &__body {
    padding-top 50px
  }
}
</style>
